import { Component, HostBinding, Input, OnChanges } from '@angular/core';
import { BREAKPOINTS } from '@root/app.config';
import { BlindData, BlindType, GalleryViewType, GalleryViewTypes } from '@root/app.interfaces';

import * as _ from 'lodash';

const FramesOptionsArray = ['frame_color', 'top_style', 'bottom_bar'] as const;
export type FramesOptions = (typeof FramesOptionsArray)[number];

const GeneralOptionsArray = ['material', 'size', 'operation', 'mounting'] as const;
export type GeneralOptions = (typeof GeneralOptionsArray)[number];

export type BlindOptions = FramesOptions | GeneralOptions;
export type BlindOptionAvailability = Record<BlindOptions, boolean>;

@Component({
	selector: 'app-gallery-sidebar',
	templateUrl: './gallery-sidebar.component.html',
	styleUrls: ['./gallery-sidebar.component.scss', './gallery-sidebar.responsive.scss'],
})
export class GallerySidebarComponent implements OnChanges {
	@Input() blindsData: BlindData[];
	@Input() selectedType: BlindType;
	@Input() viewType: GalleryViewType = GalleryViewTypes.Default;

	@HostBinding('class') get hostClass() {
		return this.viewType;
	}

	protected readonly GalleryViewTypes = GalleryViewTypes;
	protected readonly BREAKPOINTS = BREAKPOINTS;

	protected hasExtraSizeBlind: boolean;
	protected blindOptionAvailability: BlindOptionAvailability = {
		frame_color: false,
		top_style: false,
		bottom_bar: false,
		material: false,
		size: false,
		operation: false,
		mounting: false,
	};

	ngOnChanges() {
		this.hasExtraSizeBlind = this.blindsData.some((blind) => blind.setup.size.extra_size);

		this.checkOptionsAvailability();
	}

	private checkOptionsAvailability(): void {
		for (const option of this.blindsData) {
			if (!_.isEmpty(option.setup.frames)) {
				for (const key of FramesOptionsArray) {
					if (!this.blindOptionAvailability[key]) {
						this.blindOptionAvailability[key] = !_.isEmpty(option.setup.frames[key]);
					}
				}
			}

			for (const key of GeneralOptionsArray) {
				if (!this.blindOptionAvailability[key]) {
					this.blindOptionAvailability[key] = !_.isEmpty(option.setup[key]);
				}
			}
		}
	}
}
